import React from 'react';
import { FiAlertTriangle } from 'react-icons/fi';

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null, errorInfo: null };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true };
  }

  componentDidCatch(error, errorInfo) {
    console.error('Error capturado por ErrorBoundary:', error, errorInfo);
    this.setState({
      error,
      errorInfo
    });
  }

  handleReload = () => {
    window.location.href = '/dashboard';
  };

  handleLogout = () => {
    localStorage.removeItem('token');
    localStorage.removeItem('user');
    window.location.href = '/login';
  };

  render() {
    if (this.state.hasError) {
      return (
        <div className="error-boundary-container">
          <FiAlertTriangle size={64} color="#ef4444" className="error-boundary-icon" />
          <h1 className="error-boundary-title">Algo salió mal</h1>
          <p className="error-boundary-message">
            Lo sentimos, ha ocurrido un error inesperado. Por favor, intenta recargar la página o volver al inicio de sesión.
          </p>

          {process.env.NODE_ENV === 'development' && this.state.error && (
            <details className="error-boundary-details">
              <summary className="error-boundary-details-summary">
                Detalles del error (solo en desarrollo)
              </summary>
              <pre className="error-boundary-details-pre">
                {this.state.error.toString()}
                {this.state.errorInfo && this.state.errorInfo.componentStack}
              </pre>
            </details>
          )}

          <div className="error-boundary-actions">
            <button
              onClick={this.handleReload}
              className="error-boundary-button error-boundary-button-primary"
            >
              Recargar Dashboard
            </button>
            <button
              onClick={this.handleLogout}
              className="error-boundary-button error-boundary-button-secondary"
            >
              Cerrar Sesión
            </button>
          </div>
        </div>
      );
    }

    return this.props.children;
  }
}

export default ErrorBoundary;
